(function ($) {
  const default_arrows = {
    left: '<button class="slick-prev"><i class="fas fa-chevron-left"></i><span class="sr-only">Previous</span></button>',
    right:
      '<button class="slick-next"><i class="fas fa-chevron-right"></i><span class="sr-only">Next</span></button>',
  };

  jQuery(document).ready(function () {
    $(".carousel-slick-small").slick({
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      prevArrow: default_arrows.left,
      nextArrow: default_arrows.right,
      appendArrows: $('.carousel_arrows'),
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 780,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
      ],
    });

    $(".carousel-slick-product-relate").slick({
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      prevArrow: default_arrows.left,
      nextArrow: default_arrows.right,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 780,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
      ],
    });

    $(".carousel-slick-large").slick({
      infinite: true,
      slidesToShow: 8,
      slidesToScroll: 1,
      prevArrow: default_arrows.left,
      nextArrow: default_arrows.right,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 8,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 780,
          settings: {
            slidesToShow: 6,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
      ],
    });
    
    let bs_settings = {
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      prevArrow: default_arrows.left,
      nextArrow: default_arrows.right,
      appendDots: $(".banner_slider_dots")
    };
    $(".banner_slider").slick(bs_settings);

   let bis_settings = {
     infinite: true,
     slidesToShow: 1,
     slidesToScroll: 1,
     prevArrow: default_arrows.left,
     nextArrow: default_arrows.right,
   };
   $(".banner_image_slider").slick(bis_settings);

    // Single debounced resize handler: re-slick the banners once per resize
    // settle and re-measure header padding a single time. Previously each
    // resize pixel ran unslick/reslick and spawned a new 100ms setInterval,
    // which stacked timers that never fully cleaned up.
    $(window).on('resize', debounce(function() {
      $(".banner_slider").slick("unslick");
      $(".banner_slider").slick(bs_settings);

      $(".banner_image_slider").slick("unslick");
      $(".banner_image_slider").slick(bis_settings);

      headerPadding();
    }, 150));
  });

  function debounce(fn, delay) {
    let t;
    return function() {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, arguments), delay);
    };
  }

  function headerPadding() {
    let h = $('.header_fixed').height();
    $("body").css("padding-top", h + "px").css('transition', 'padding 0.1s ease-in');
    return h;
  }
})(jQuery);
